import { apiClient } from "@/services/api.client"
import type { Thread } from "@/types"

export const casesService = {
  list: () => apiClient.get<Thread[]>("/api/v1/threads/"),

  get: (threadId: string) => apiClient.get<Thread>(`/api/v1/threads/${threadId}`),

  create: (title: string, serviceId: string, userId: string, extraMetadata: Record<string, unknown> = {}) =>
    apiClient.post<Thread>("/api/v1/threads/", {
      title,
      metadata: { user_id: userId, service_id: serviceId, ...extraMetadata },
    }),

  update: (
    threadId: string,
    patch: Partial<{ title: string; metadata: Record<string, unknown> }>
  ) => apiClient.patch<Thread>(`/api/v1/threads/${threadId}`, patch),

  delete: (threadId: string) => apiClient.delete<void>(`/api/v1/threads/${threadId}`),
}
